export default __webpack_public_path__ + "static/media/Queue.5d3f80d2.jpg";